import React, {useState, useEffect, useRef , useContext } from 'react';
import { Table, Form, Input, Row, Col, Button, InputNumber, Space, Modal, Popconfirm } from 'antd';
import { DeleteOutlined, FolderViewOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import AddDecklist from './AddDecklist';
import { useTranslation } from 'react-i18next';

const EditableContext = React.createContext(null);

function ParticipantTable(props) {
    const [dataSource, setDataSource] = useState(props.dataSource)
    const [modalActive, setModalActive] = useState(false);
    const { t } = useTranslation();

      const participantsColEdit = [
      {
        title: t('players.name'),
        dataIndex: 'playerName',
        key: 'name', 
        editable: false,
        render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
      },
  /*     {
        title: 'Nome',
        dataIndex: 'playerName',
        key: 'name', 
      },
      {
        title: 'Cognome',
        dataIndex: 'playerSurname',
        key: 'surname',
      }, */
    ];
  
    // console.warn('props di rankingtable', props)
    function generateParticipantsCols(props) {
      let participantsCol;
      if (props.rights.isAdmin || props.rights.isReferral) {
        participantsCol = [
            {
              title: t('columns.position'),
              dataIndex: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
              key: (props.isTournament ? 'rankingPlace' : 'stagePlace'), 
              editable: true
            },
            {
              title: t('players.name'),
              dataIndex: 'playerName',
              key: 'name', 
              editable: false,
              render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
            },
            {
              title: t('decks.name'),
              dataIndex: 'deckName',
              key: 'deckName',
              editable: true,
              render: (state, record) => {
                if (record.deckId > 0 ) {
                  return (<Space> {record.deckName} 
                        <Link to={'/decks/'+record.deckId+'/'}>
                          <FolderViewOutlined style={{ fontSize: '25px' }} />
                        </Link>
                      </Space>);
                }
                // if (props.rights && (props.rights.isAdmin || props.rights.isReferral)){
                //  return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
                // }
                return (<Space> {record.deckName} </Space>);
              }
            },
            {
              title: t('common.actions'),
              dataIndex: 'playerId',
              key: 'playerId',
              render: (state, record) => (
                  (<div>
                    { record.deckId <= 0 && (
                      <Space style={{ marginRight: '3px' }}><AddDecklist player={record} {...props} /></Space>
                    )}
                    <Space>
                      <Popconfirm
                          title="Delete participant"
                          description="Are you sure to remove this player from event?"
                          onConfirm={(e) => {e.preventDefault(); onDeletePlayer(record)}}
                          okText="Yes"
                          cancelText="No"
                      >
                        <Button size="small" danger icon={<DeleteOutlined />}/>
                      </Popconfirm>
                    </Space>
                    </div>)
                )
            }
        ]; // onClick={() => onDeletePlayer(record)}
      } else {
        participantsCol = [
          {
            title: t('players.name'),
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
        ];
      }

      return participantsCol;
    }

/*    let participantsCol; 
      if (props.rights.isAdmin || props.rights.isReferral) {
      participantsCol = [
          {
            title: t('columns.position'),
            dataIndex: (props.isTournament ? 'rankingPlace' : 'stagePlace'),
            key: (props.isTournament ? 'rankingPlace' : 'stagePlace'), 
            editable: true
          },
          {
            title: t('players.name'),
            dataIndex: 'playerName',
            key: 'name', 
            editable: false,
            render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
          },
          {
            title: t('decks.name'),
            dataIndex: 'deckName',
            key: 'deckName',
            editable: true,
            render: (state, record) => {
              if (record.deckId > 0 ) {
                return (<Space> {record.deckName} 
                      <Link to={'/decks/'+record.deckId+'/'}>
                        <FolderViewOutlined style={{ fontSize: '25px' }} />
                      </Link>
                    </Space>);
              }
              // if (props.rights && (props.rights.isAdmin || props.rights.isReferral)){
              //  return (<Space> {record.deckName}<AddDecklist player={record} {...props}/></Space>);
              // }
              return (<Space> {record.deckName} </Space>);
            }
          },
          {
            title: t('common.actions'),
            dataIndex: 'playerId',
            key: 'playerId',
            render: (state, record) => (
                (<div>
                  <Space style={{ marginRight: '3px' }}><AddDecklist player={record} {...props} /></Space>
                  <Space><Button size="small" icon={<DeleteOutlined />} onClick={() => onDeletePlayer(record)}/></Space>
                  </div>)
              )
          }
      ];
    } else {
      participantsCol = [
        {
          title: t('players.name'),
          dataIndex: 'playerName',
          key: 'name', 
          editable: false,
          render: (state, record) => (<span>{record.playerName} {record.playerSurname}</span>) 
        },
      ];
    } */

    useEffect(() => {
        setDataSource(props.dataSource)
    }, [props.dataSource])

    function onDeletePlayer(participant) {
      // console.warn('arrivato alla chiamata ajax! ', participant)
      props.deletePlayer.mutate(participant)
      // window.location.reload(false)
    }

    function onConfirm(event) {
      event.preventDefault();
      setModalActive(true);
    }

    function onSave(event) {
        event.preventDefault()
        // alert("salvo la classifica!")
        // console.warn('params di rankingtable', stageId)
        // console.warn('params di rankingtable', props.stage.payLoad.id)
        const mo = {
          stageId: props.stage.payLoad.id,
          players: dataSource,
        }
        props.toggleEditing(event)
        props.updateRanking.mutate(mo)
        setModalActive(false);
    }

    const handleSave = (row) => {
        // console.warn('riga modificata:',row)
        const newData = [...dataSource];
        const index = newData.findIndex((item) => row.playerId === item.playerId);
        const item = newData[index];
        newData.splice(index, 1, { ...item, ...row });
        setDataSource(newData);
      };

    if (props.editing === false) {
        return (
            <Table 
            size="small" 
            columns={generateParticipantsCols(props)}
            dataSource={dataSource}
            pagination={false}
            loading={props.participants && !props.participants.fulfilled && props.participants.pending}
            title={() => 'Participants'}
          />
        )
    } else {
        const EditableRow = ({ index, ...props }) => {
            const [form] = Form.useForm();
            return (
              <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                  <tr {...props} />
                </EditableContext.Provider>
              </Form>
            );
          };
          
          const EditableCell = ({
            title,
            editable,
            inputType,
            children,
            dataIndex,
            record,
            handleSave,
            ...restProps
          }) => {
            const [editing, setEditing] = useState(false);
            const inputRef = useRef(null);
            const form = useContext(EditableContext);
            useEffect(() => {
              if (editing) {
                inputRef.current.focus();
              }
            }, [editing]);
          
            const toggleEdit = () => {
              setEditing(!editing);
              form.setFieldsValue({
                [dataIndex]: record[dataIndex],
              });
            };
          
            const save = async () => {
              try {
                const values = await form.validateFields();
                toggleEdit();
                handleSave({ ...record, ...values });
              } catch (errInfo) {
                console.log('Save failed:', errInfo);
              }
            };
          
            let childNode = children;
          
            if (editable) {
              /* childNode = editing ? (
                <Form.Item
                  style={{
                    margin: 0,
                  }}
                  name={dataIndex}
                  rules={[
                    {
                      required: true,
                      message: `${title} is required.`,
                    },
                  ]}
                >
                  <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                </Form.Item>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{
                    paddingRight: 24,
                  }}
                  onClick={toggleEdit}
                >
                  {children}
                </div>
              ); */

              if (editing) {
                if (inputType === 'number') {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <InputNumber ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                } else {
                  childNode = (
                    <Form.Item
                      style={{
                        margin: 0,
                      }}
                      name={dataIndex}
                      rules={[
                        {
                          required: true,
                          message: `${title} is required.`,
                        },
                      ]}
                    >
                      <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                    </Form.Item>
                  );
                }
              } else {
                childNode = (
                  <div
                    className="editable-cell-value-wrap"
                    style={{
                      paddingRight: 24,
                    }}
                    onClick={toggleEdit}
                  >
                    {children}
                  </div>
                );
              }
            }
          
            return <td {...restProps}>{childNode}</td>;
          };

          const components = {
            body: {
              row: EditableRow,
              cell: EditableCell,
            },
          };

          const columns = participantsColEdit.map((col) => {
            if (!col.editable) {
              return col;
            }
        
            return {
              ...col,
              onCell: (record) => ({
                record,
                editable: col.editable,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave,
              }),
            };
          });
        return (
            <>
                <Row justify="center" style={{ marginBottom: '10px' }}>
                    <Col span={4}><Button type="primary" danger onClick={props.toggleEditing}>{t('common.cancel')}</Button></Col>
                    <Col span={4}><Button onClick={(event) => onConfirm(event)}>{t('common.save')}</Button></Col>
                </Row>
                <Modal title="Confirm Save" open={modalActive} onOk={(event) => onSave(event)} onCancel={() => setModalActive(false)} okText={t('common.confirm')} cancelText={t('common.cancel')}>
                    <p>By clicking OK, your changes will be saved and the stage will be closed.<br/> Continue?</p>
                </Modal>
                <Table
                    components={components}
                    rowClassName={() => 'editable-row'}
                    dataSource={dataSource}
                    columns={columns}
                    pagination={false}
                />
            </>
            
        )
    }
}

export default ParticipantTable;